import React from 'react';

import './i18n';
import { CurrentUser, QualioQFrontEndProvider } from '@qualio/ui-components';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot, Root } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ErrorBoundary } from 'v2views';

import App from './App';
import './styles.css';

// Store roots for cleanup in MFE architecture
const roots = new Map<string, Root>();

(window as any).renderSupplierQualityManagement = async (
  containerId: string,
  currentUser: CurrentUser,
  analytics: SegmentAnalytics.AnalyticsJS,
) => {
  // TODO: Resolve hacky way to add datepicker css -- start
  const head = document.getElementsByTagName('HEAD')[0];
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/react-datepicker/2.14.1/react-datepicker.min.css';
  head.appendChild(link);
  // Resolve hacky way to add datepicker css -- end

  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LD_PK as string,
    user: {
      key: `${currentUser?.companyId}`,
      custom: {
        loggedInUserId: `${currentUser?.userId}`,
        createdTime: `${currentUser.company?.createdTime}`,
        status: `${currentUser.company?.status}`,
      },
    },
    options: {},
  });

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  // Manually detect & add basename when opening new tab
  // until https://qualio.atlassian.net/browse/UX-173 is implemented and the CL is upgraded.
  if (!window.location.pathname.includes('/sqm')) {
    window.history.replaceState('', '', '/sqm' + window.location.pathname);
  }

  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Container #${containerId} not found`);
    return;
  }

  const root = createRoot(container);
  roots.set(containerId, root);

  root.render(
    <ErrorBoundary>
      <QualioQFrontEndProvider user={currentUser} analytics={analytics}>
        <LDProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </LDProvider>
      </QualioQFrontEndProvider>
    </ErrorBoundary>,
  );
};

(window as any).unmountSupplierQualityManagement = (containerId: string) => {
  const root = roots.get(containerId);
  if (root) {
    root.unmount();
    roots.delete(containerId);
  }
};

if (process.env.REACT_APP_MOCK) {
  import('./mocks');
}
